<template>
  <div class="tla-form-group" v-if="showFundingType">
    <label class="tla-form-group__label tla-form-group__label--required">{{fundingTypeLabel}} <span>*</span></label>

    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in options"
        :key="item.touchpointValue"
        :collectionName="'fundingType'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isSelected="item.preSelect"
        :isFullWidth="true"
        :validationScope="validationScope"
        @fundingType="submitFundingType($event)">
        <touchpointText slot="touchpoint" :content="item.touchpointName"></touchpointText>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('fundingType', 'message')">
      Please select an option.
    </span>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { Validator } from 'vee-validate';
import {
  Component, Prop, Inject, Watch
} from 'vue-property-decorator';
import FundingType from '@/enums/FundingType';
import { validationService } from '@/services/ValidationService';
import PurchaseType from '@/enums/PurchaseType';
import Touchpoint from '../../models/Touchpoint';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import PurchaseTypeGroup from '../../enums/PurchaseTypeGroup';
import GenericTouchPointTextComponent from '../ui/GenericTouchPointTextComponent.vue';
import ExtraData from '../../models/ExtraData';

@Component({
  components: {
  touchpoint: GenericTouchPointComponent,
  touchpointText: GenericTouchPointTextComponent
  }
  })
export default class FundingTypeComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'How are you looking to fund your purchase?' })
  public fundingTypeLabel!: string;

  @Prop({ default: false })
  public showIfOutright!: boolean;

  @Prop({ default: null })
  public validationScope!: string;

    @Prop({ default: false })
  public forceFundingType!: boolean;

  @Prop({ default: FundingType.Cash })
  public selectedFundingType!: FundingType;

  public options: Touchpoint[] = [
    new Touchpoint(`${FundingType.Cash}`, 'Cash'),
    new Touchpoint(`${FundingType.Loan}`, 'Loan'),
    new Touchpoint(`${FundingType.Remortgage}`, 'Remortgage'),
    new Touchpoint(`${FundingType.NotSure}`, 'Not Sure')
  ];

  public submitFundingType(value: string) {
    const fundingType: FundingType = FundingType[value];
    this.$store.dispatch('financeModule/submitFundingType', fundingType);
    this.$store.dispatch('financeModule/submitPurchaseTypes', [PurchaseType.Outright]);

    if (value === FundingType.NotSure.toString()) {
      const extraData: ExtraData = new ExtraData('fundingTypeNotSure', 'true');
      this.$store.dispatch('enquiryModule/submitExtraData', extraData);
    } else {
      this.$store.dispatch('enquiryModule/submitRemoveExtraData', 'fundingTypeNotSure');
    }
  }

  public get purchaseTypeGroup(): PurchaseTypeGroup {
    return this.$store.getters['financeModule/purchaseTypeGroup'];
  }

  public get showFundingType(): boolean {
    return ((this.purchaseTypeGroup === PurchaseTypeGroup.Outright && this.showIfOutright) || !this.showIfOutright) && !this.forceFundingType;
  }

  @Watch('showFundingType')
  public onshowFundingTypeChanged() {
    this.$store.dispatch('enquiryModule/submitRemoveExtraData', 'fundingTypeNotSure');
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }

  public created() {
    if (this.forceFundingType) {
      this.submitFundingType(`${this.selectedFundingType}`);
    }
  }
}
</script>
